import { render } from "./AdicionarUsuario.vue?vue&type=template&id=28752b26&scoped=true"
import script from "./AdicionarUsuario.vue?vue&type=script&lang=js"
export * from "./AdicionarUsuario.vue?vue&type=script&lang=js"

import "./AdicionarUsuario.vue?vue&type=style&index=0&id=28752b26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28752b26"]])

export default __exports__